var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7417 4C10.7417 6.20914 8.95084 8 6.7417 8C4.53256 8 2.7417 6.20914 2.7417 4C2.7417 1.79086 4.53256 0 6.7417 0C8.95084 0 10.7417 1.79086 10.7417 4ZM8.7417 4C8.7417 5.10457 7.84627 6 6.7417 6C5.63713 6 4.7417 5.10457 4.7417 4C4.7417 2.89543 5.63713 2 6.7417 2C7.84627 2 8.7417 2.89543 8.7417 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7417 12C10.7417 11.4477 10.294 11 9.7417 11H3.7417C3.18941 11 2.7417 11.4477 2.7417 12V18H0.741699V12C0.741699 10.3431 2.08485 9 3.7417 9H9.7417C11.3986 9 12.7417 10.3431 12.7417 12V18H10.7417V12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3dfb98d33917fe0e5be96b75ca29276a.svg";
export { ForwardRef as ReactComponent };